// Copyright © 2021 Move Closer
/**
 * Tile's sizing variant.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var TileVersion;
(function (TileVersion) {
    TileVersion["S"] = "S";
    TileVersion["L"] = "L";
    TileVersion["XL"] = "XL";
    TileVersion["FourColumns"] = "4-columns";
    TileVersion["FiveColumns"] = "5-columns";
})(TileVersion || (TileVersion = {}));
export var Breakpoint;
(function (Breakpoint) {
    Breakpoint["XS"] = "xs";
    Breakpoint["SM"] = "sm";
    Breakpoint["MD"] = "md";
    Breakpoint["LG"] = "lg";
    Breakpoint["XL"] = "xl";
    Breakpoint["XXL"] = "xxl";
})(Breakpoint || (Breakpoint = {}));
